import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';

import styles from './styles.module.scss';
import { KnmSubtitle } from './KnmSubtitle';

interface IKnmProsecutor {
  passportData?: IKnmPreview;
}

export const KnmProsecutor = ({ passportData }: IKnmProsecutor) => (
  <div className={styles.ColumnContent}>
    <KnmSubtitle title="Орган прокуратуры">
      {passportData?.prosecName && (
        <div className={styles.Row}>
          <div className={styles.ColText}>Наименование прокуратуры</div>
          <div className={styles.ColValue}>{passportData?.prosecName}</div>
        </div>
      )}
    </KnmSubtitle>
  </div>
);
